import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';

import CountrySelect from './CountrySelect';
import StateSelect from './StateSelect';
import { useStyles } from '../checkoutDrawer.styles';

function BillingAddress ({ form, fieldErrors, states, setField, handleBlur }) {
    const classes = useStyles();

    return (
        // Billing address — field ids are prefixed `co-` (checkout) to avoid
        // colliding with the billing form's plain `email`/`firstName` ids.
        <div>
            <p className={classes.sectionLabel}>Billing address</p>
            <div className={classes.formGrid}>
                <TextField
                    id="co-email"
                    label="Email"
                    required
                    type="email"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className={classes.textField}
                    value={form.email}
                    onChange={(e) => setField('email', e.target.value)}
                    onBlur={() => handleBlur('email')}
                    error={!!fieldErrors.email}
                    helperText={fieldErrors.email}
                />

                <div className={classes.formRow}>
                    <TextField
                        id="co-firstName"
                        label="First name"
                        required
                        type="text"
                        variant="outlined"
                        size="small"
                        fullWidth
                        className={classes.textField}
                        value={form.firstName}
                        onChange={(e) => setField('firstName', e.target.value)}
                        onBlur={() => handleBlur('firstName')}
                        error={!!fieldErrors.firstName}
                        helperText={fieldErrors.firstName}
                    />
                    <TextField
                        id="co-lastName"
                        label="Last name"
                        required
                        type="text"
                        variant="outlined"
                        size="small"
                        fullWidth
                        className={classes.textField}
                        value={form.lastName}
                        onChange={(e) => setField('lastName', e.target.value)}
                        onBlur={() => handleBlur('lastName')}
                        error={!!fieldErrors.lastName}
                        helperText={fieldErrors.lastName}
                    />
                </div>

                <TextField
                    id="co-address"
                    label="Address"
                    required
                    type="text"
                    variant="outlined"
                    size="small"
                    fullWidth
                    className={classes.textField}
                    value={form.address}
                    onChange={(e) => setField('address', e.target.value)}
                    onBlur={() => handleBlur('address')}
                    error={!!fieldErrors.address}
                    helperText={fieldErrors.address}
                />

                <div>
                    <CountrySelect
                        value={form.country}
                        onChange={(iso2) => setField('country', iso2)}
                        onBlur={() => handleBlur('country')}
                        error={!!fieldErrors.country}
                    />
                    {fieldErrors.country && (
                        <span className={classes.fieldError} role="alert">{fieldErrors.country}</span>
                    )}
                </div>

                <div>
                    <StateSelect
                        value={form.state}
                        options={states}
                        onChange={(val) => setField('state', val)}
                        onBlur={() => handleBlur('state')}
                        error={!!fieldErrors.state}
                        disabled={states.length === 0}
                    />
                    {fieldErrors.state && (
                        <span id="co-state-err" className={classes.fieldError} role="alert">{fieldErrors.state}</span>
                    )}
                </div>

                <div className={classes.formRow}>
                    <TextField
                        id="co-city"
                        label="City"
                        required
                        type="text"
                        variant="outlined"
                        size="small"
                        fullWidth
                        className={classes.textField}
                        value={form.city}
                        onChange={(e) => setField('city', e.target.value)}
                        onBlur={() => handleBlur('city')}
                        error={!!fieldErrors.city}
                        helperText={fieldErrors.city}
                    />
                    <TextField
                        id="co-zip"
                        label="ZIP / Postcode"
                        required
                        type="text"
                        variant="outlined"
                        size="small"
                        fullWidth
                        className={classes.textField}
                        value={form.zip}
                        onChange={(e) => setField('zip', e.target.value)}
                        onBlur={() => handleBlur('zip')}
                        error={!!fieldErrors.zip}
                        helperText={fieldErrors.zip}
                    />
                </div>
            </div>
        </div>
    );
}

BillingAddress.propTypes = {
    form: PropTypes.shape({
        email: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        address: PropTypes.string,
        city: PropTypes.string,
        country: PropTypes.string,
        state: PropTypes.string,
        zip: PropTypes.string,
    }).isRequired,
    fieldErrors: PropTypes.object.isRequired,
    states: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    })).isRequired,
    setField: PropTypes.func.isRequired,
    handleBlur: PropTypes.func.isRequired,
};

export default BillingAddress;
